import {observer} from 'mobx-react';
import React from 'react';

import {TrackerInitializer} from '@udemy/event-tracking';
import {Footer} from '@udemy/footer';
import {Header, SearchBarMXEnum} from '@udemy/react-header';
import {Toaster} from '@udemy/react-messaging-components';
import {useStores} from '@udemy/store-provider';

import {RootStore} from 'src/stores/root-store';

import styles from './layout.module.less';

/**
 * Page shell rendered by `getLayout`.
 *
 * This file is `file.Once`, so stencil never overwrites it. It replaces the default `Layout`
 * from `layout.tsx` to keep the homepage-specific behavior below.
 */
export const AppLayout = observer(({children}: {children: React.ReactElement}) => {
    const [rootStore] = useStores([RootStore]);
    /**
     * This is for mobile webview renders. Normally we shouldn't be going to here but this is a legacy support from
     * django that integrated all over our apps so we need to support it.
     */
    const shouldRenderHeaderAndFooter = () => {
        if (typeof window !== 'undefined') {
            const displayTypeParam = new URLSearchParams(window.location.search).get(
                'display_type',
            );
            return displayTypeParam !== 'mobile_app';
        }
        return true;
    };
    return (
        <>
            <div className={styles['container']}>
                {shouldRenderHeaderAndFooter() && (
                    <Header
                        {...rootStore.headerData}
                        showTwoRowSearchBarMX={SearchBarMXEnum.OldBar}
                    />
                )}
                <main className={styles['content']} id="main-content-anchor">
                    {children}
                </main>
                {shouldRenderHeaderAndFooter() && (
                    <Footer clientProps={rootStore.footerData} serverProps={rootStore.footerData} />
                )}
                <Toaster />
            </div>
            <TrackerInitializer />
        </>
    );
});
